// STY-445/446: PostHog capture-mode model — parity with react-frontend / nextjs (and the fb-clips
// monorepo). PostHog captures EVERYONE consent-free; this resolves a per-visitor CaptureMode from
// geo (the geo_eu cookie) + GPC that controls:
//   - persistence: 'memory' (storage-less) for the cookieless modes, else 'localStorage'
//   - whether session replay may run (never in the cookieless modes)
// Every event is stamped with `capture_mode` (super-property) so suppression/coverage is measurable.
//
// NOTE: submissions mirrors react/next exactly — it does NOT identify anyone (resolveCaptureMode is
// called with no auth), so logged-in submitters resolve to anon_logged_out, same as react/next.
import { isEuVisitor, hasGlobalPrivacyControl } from './geo'

export const CAPTURE_MODES = {
  IDENTIFIED: 'identified',
  ANON_CONSENT_LOCALE: 'anon_consent_locale',
  ANON_GPC: 'anon_gpc',
  ANON_LOGGED_OUT: 'anon_logged_out'
}

// Most-restrictive reason wins:
//   1. consent-locale (EU/EEA/UK/CH/CA via geo_eu; fail-safe to strict when geo is missing)
//   2. GPC opt-out
//   3. logged-out
//   4. else identified
export function resolveCaptureMode ({ isAuthenticated } = {}) {
  if (isEuVisitor()) return CAPTURE_MODES.ANON_CONSENT_LOCALE
  if (hasGlobalPrivacyControl()) return CAPTURE_MODES.ANON_GPC
  if (!isAuthenticated) return CAPTURE_MODES.ANON_LOGGED_OUT
  return CAPTURE_MODES.IDENTIFIED
}

// Cookieless / storage-less modes: persistence:'memory', never person-tied, no session replay.
export function isCookielessMode (mode) {
  return mode === CAPTURE_MODES.ANON_CONSENT_LOCALE || mode === CAPTURE_MODES.ANON_GPC
}
